'use client';
import type { XYChartSparkPoint } from './xychart-sparkline-model';
export interface XYChartLineSparkEndpointProps {
    point: XYChartSparkPoint;
    height: number;
    trendColor: string;
}
export function XYChartLineSparkEndpoint({ point, height, trendColor, }: XYChartLineSparkEndpointProps) {
    return (
      <g>
        <line x1={point.x} y1={point.y} x2={point.x} y2={height} stroke={trendColor} strokeWidth={1.5} strokeDasharray="4 4" opacity={0.4}/>
        <circle cx={point.x} cy={point.y} r={20} fill="none" stroke={trendColor} strokeWidth={1} opacity={0.3}/>
        <circle cx={point.x} cy={point.y} r={12} fill={trendColor} opacity={0.3}/>
        <circle cx={point.x} cy={point.y} r={5} fill="#ffffff" stroke={trendColor} strokeWidth={2}/>
      </g>
    );
}
